/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Find_Replace_No_Results_FoundInputs */

const en_find_replace_no_results_found = /** @type {(inputs: Find_Replace_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Results Found`)
};

const fr_find_replace_no_results_found = /** @type {(inputs: Find_Replace_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun resultat trouve`)
};

const de_find_replace_no_results_found = /** @type {(inputs: Find_Replace_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ergebnisse gefunden`)
};

const it_find_replace_no_results_found = /** @type {(inputs: Find_Replace_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato trovato`)
};

const ru_find_replace_no_results_found = /** @type {(inputs: Find_Replace_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты не найдены`)
};

const es_find_replace_no_results_found = /** @type {(inputs: Find_Replace_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron resultados`)
};

const zh_cn2_find_replace_no_results_found = /** @type {(inputs: Find_Replace_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到结果`)
};

const ja_find_replace_no_results_found = /** @type {(inputs: Find_Replace_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果が見つかりませんでした`)
};

const hi_find_replace_no_results_found = /** @type {(inputs: Find_Replace_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई परिणाम नहीं मिला`)
};

const pt_pt2_find_replace_no_results_found = /** @type {(inputs: Find_Replace_No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado encontrado`)
};

/**
* | output |
* | --- |
* | "No Results Found" |
*
* @param {Find_Replace_No_Results_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const find_replace_no_results_found = /** @type {((inputs?: Find_Replace_No_Results_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Find_Replace_No_Results_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_find_replace_no_results_found(inputs)
	if (locale === "de") return de_find_replace_no_results_found(inputs)
	if (locale === "it") return it_find_replace_no_results_found(inputs)
	if (locale === "ru") return ru_find_replace_no_results_found(inputs)
	if (locale === "es") return es_find_replace_no_results_found(inputs)
	if (locale === "zh-CN") return zh_cn2_find_replace_no_results_found(inputs)
	if (locale === "ja") return ja_find_replace_no_results_found(inputs)
	if (locale === "hi") return hi_find_replace_no_results_found(inputs)
	if (locale === "pt-PT") return pt_pt2_find_replace_no_results_found(inputs)
	return en_find_replace_no_results_found(inputs)
});